import { Component, Input, TemplateRef } from '@angular/core'
import { RootState } from '@helios/state-management'
import { Store } from '@ngrx/store'
import { getIsAccountLoaded } from '../content-predicate-streams'

@Component({
  selector: 'hs-no-loaded-account',
  styleUrls: ['no-loaded-account.component.scss'],
  templateUrl: 'no-loaded-account.component.html',
})
export class NoLoadedAccountComponent {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() content: TemplateRef<any> | null = null

  readonly isSessionActiveWithAccounts$ = getIsAccountLoaded(this.store)

  constructor(private readonly store: Store<RootState>) {}
}
